export default {
	name: 'account-about-modal',
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			versionCode: process.env.VERSION_CODE
		};
	},
	methods: {
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/account');
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/account-about-modal/script.js